// extracted by mini-css-extract-plugin
module.exports = {"paper":"ErrorComponent_paper__37Zfr","mainfild":"ErrorComponent_mainfild__1X3L5","contentserror":"ErrorComponent_contentserror__31G7F","message":"ErrorComponent_message__h2B0H"};